<template>
  <div>
    <TransactionHero />
    <TransactionMain />
  </div>
</template>

<script>
import TransactionHero from "@/components/TransactionHero.vue";
import TransactionMain from "@/components/TransactionMain.vue";
export default {
  components: {
    TransactionHero,
    TransactionMain
  }
};
</script>

<style lang="scss" scoped></style>
